// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Ioja","list":"PatternAutocomplete_list__3d3gb"};